import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from '@tecommon/ui/components/localStorage/localStorage.service';
import { SessionCheck } from '../../services/sessionCheck/sessionCheck.service';
//import { win32 } from 'path';

declare var document: any;  //so that typescript compiler will leave me alone below... 

@Component({
    selector: 'root',
    templateUrl: 'root.component.html',
    standalone: false
})
export class RootComponent {

    showHeaderFooter: boolean = true;
    // More info on this project here -> https://github.com/ngx-translate/core
    constructor(translate: TranslateService, private readonly localStorage: LocalStorage, private readonly sessionCheck: SessionCheck) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        const lang = this.localStorage.getItem("language");
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        if (lang)
            document.language = lang;
        else
            this.localStorage.setItem("language", "en");

        translate.use(document.language);
       
        /*  The code below was attempted to help if someone hit "refresh".. it will log them out!  Do we want this?  */
        if (location.href.indexOf('SDContacts') > -1) {
            this.showHeaderFooter = false;
        } else {
            this.showHeaderFooter = true;
        }
       
    }
}
